var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 11a1 1 0 01-.707-.293L.586 6 2 4.586l4 4 8-8L15.414 2l-8.707 8.707A1 1 0 016 11z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }